<template>
  <div id="SectionTrackRecord">
    <UIContainer class="SectionTrackRecord__container">
      <template #left>
        <SectionTitle titleSize="sm">
          <template #heading> Our Track Record </template>
          <template #title> Your success is our guarantee </template>

          <template #description> We stand behind our results </template>
        </SectionTitle>

        <div class="SectionTrackRecord__badges">
          <div class="SectionTrackRecord__badge">
            <div class="SectionTrackRecord__badge-high-satisfaction">98%</div>
            <div class="SectionTrackRecord__badge-description">
              Consistently high user satisfaction
            </div>
          </div>
          <div class="SectionTrackRecord__badge">
            <UIIcon class="SectionTrackRecord__badge-worldwide" name="globe" />
            <div class="SectionTrackRecord__badge-description">
              Trusted by leading companies worldwide
            </div>
          </div>
          <div class="SectionTrackRecord__badge">
            <img
              class="SectionTrackRecord__badge-img"
              src="./assets/trackRecord/efrag.avif"
              alt="EFRAG certification"
              loading="lazy"
              height="60"
            />
            <div class="SectionTrackRecord__badge-description">
              Friends of EFRAG sustainability reporting
            </div>
          </div>
          <div class="SectionTrackRecord__badge">
            <img
              class="SectionTrackRecord__badge-img"
              src="./assets/trackRecord/ghg.avif"
              alt="GHG Protocol certification"
              loading="lazy"
              height="60"
            />
            <div class="SectionTrackRecord__badge-description">
              Compliant with global GHG reporting standards
            </div>
          </div>
        </div>
      </template>

      <template #right>
        <img
          class="SectionTrackRecord__image"
          src="./assets/trackRecord/bg.avif"
          alt="Track Record"
        />
      </template>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import UIIcon from '@/views/components/ui/icons/UIIcon.vue'
</script>

<style lang="scss" scoped>
#SectionTrackRecord {
  position: relative;
  background-color: $color-white;

  :deep(.UIContainer__left) {
    @include md {
      padding-right: 3rem;
    }
  }

  .SectionTrackRecord__content {
    padding: 1rem 0;
    @include md {
      margin-left: 6rem;
    }
  }

  .SectionTrackRecord__badges {
    margin-top: 3rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;

    @include md {
      gap: 1.25rem;
    }
  }

  .SectionTrackRecord__badge {
    background: $color-ui-gray-cool-50;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @include md {
      padding: 1.25rem;
    }

    .SectionTrackRecord__badge-description {
      @include font-size-16px();
      font-weight: 400;
      color: $color-ui-gray-cool-600;
      margin-top: 0.5rem;
    }

    .SectionTrackRecord__badge-high-satisfaction {
      font-size: 3.75rem;
      font-weight: 600;
      color: $color-ui-brand-700;
    }

    .SectionTrackRecord__badge-worldwide {
      --size: 4.5rem;
      align-self: self-start;
      --color: #{$color-ui-brand-700};
    }

    .SectionTrackRecord__badge-img {
      align-self: self-start;
    }
  }

  .SectionTrackRecord__square {
    width: 100%;
    max-width: 96px;
    aspect-ratio: 1 / 1;
    border-radius: 0.5rem;
    background: $color-ui-gray-cool-200;
    border: 2px dashed $color-ui-gray-cool-400;
  }

  .SectionTrackRecord__image {
    display: none;
    @include md {
      display: block;
      padding-left: 1rem;
    }
  }
}
</style>
